<template>
  <div>
    <b-card sub-title="Treatment Details (Medicine Name, Dosage, Number Of Days)">
      <div v-for="(v, index) in $v.treatments.$each.$iter" :key="index">
        <hr v-if="index > 0" class="treatments-row"/>
        <b-row >
          <b-col lg="4"><b-form-input type="text" class="form-control" v-model="v.name.$model" :state="chkState('name', index)" placeholder="Medicine Name" ></b-form-input></b-col>
          <b-col lg="4"><b-form-input type="text" class="form-control" v-model="v.dosage.$model" :state="chkState('dosage', index)" placeholder="Dosage"></b-form-input></b-col>
          <b-col lg="4"><b-form-input type="number" class="form-control" v-model="v.days.$model" :state="chkState('days', index)" placeholder="No of Days"></b-form-input></b-col>
        </b-row>
      </div>
    </b-card>

    <div class="alert alert-danger" v-if="!$v.treatments.required && $v.treatments.$dirty">Please provide at least one Treatment</div>
  </div>

</template>

<script>
import Vue from 'vue'

import {
  required
} from "vuelidate/lib/validators"

export default {
  name: 'TreatmentList',
  computed: {
    isValid() {
      return !this.$v.treatments.$anyError
    },
    isDirty() {
      return this.$v.treatments.$anyDirty
    }
  },
  data: function () {
    return {
      total: 0,
      treatments: []
    };
  },
  validations: {
    treatments: {
      required,
      $each: {
        name: {
          required,
        },
        dosage: {
          required
        },
        days: {
          required
        }
      }
    }
  },
  methods: {

    addTreatment() {
      this.treatments.push({name: "", dosage: "", days: 0})
    },
    removeTreatment() {
      this.treatments.pop()
    },
    getTreatments() {
      return this.treatments
    },
    setTreatment(treatment) {
      this.onReset()
      this.treatments.push({name: treatment.name, dosage: treatment.dosage, days: treatment.days})
    },
    onReset() {
      this.treatments = []
      this.$nextTick(() => {
        this.$v.$reset()
      })
    },
    chkState(val, index) {
      const field = this.$v.treatments.$each[index][val]
      return field.$dirty ? !field.$invalid : null
    },
    findFirstError(component = this) {
      if (component.state === false) {
        if (component.$refs.input) {
          component.$refs.input.focus()
          return true
        }
        if (component.$refs.check) {
          component.$refs.check.focus()
          return true
        }
      }
      let focused = false
      component.$children.some((child) => {
        focused = this.findFirstError(child)
        return focused
      })

      return focused
    },
    validate() {
      this.$v.$touch()
      this.$nextTick(() => this.findFirstError())
      return this.isValid
    }
  },
  created() {

  },
}
</script>

<style>
.treatments-row {
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
</style>
